import { api } from './core'

export const noticeApi = {
  list: (page) => api.get('/notice/medi', { page }),
  detail: (id) => api.get('/notice', { id }),
}
